import { render, staticRenderFns } from "./NewCreateAulaInfantil.vue?vue&type=template&id=17835e0f&scoped=true"
import script from "./NewCreateAulaInfantil.vue?vue&type=script&lang=js"
export * from "./NewCreateAulaInfantil.vue?vue&type=script&lang=js"
import style0 from "./NewCreateAulaInfantil.vue?vue&type=style&index=0&id=17835e0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17835e0f",
  null
  
)

export default component.exports